  $(document).ready(function () {
    $(".custom_tab #read-more").click(function () {
       console.log("this is the click");
        $(".custom_tab #truncated-table").hide();
        $(".custom_tab #full-table").show();
        $(this).hide();
        $(".custom_tab #read-less").show();
    });
    $(".custom_tab #read-less").click(function () {
        $(".custom_tab #truncated-table").show();
        $(".custom_tab #full-table").hide();
        $(this).hide();
        $(".custom_tab #read-more").show();
    });

   $(".close-pro-hide").click(function () {
     $(".product-quick-add").hide();
   });
    
});